var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStoplightGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4066_9754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.5C12.0196 19.5 14.4359 18.4991 16.2175 16.7175C17.9991 14.9359 19 12.5196 19 10C19 7.48044 17.9991 5.06408 16.2175 3.28249C14.4359 1.50089 12.0196 0.5 9.5 0.5C6.98044 0.5 4.56408 1.50089 2.78249 3.28249C1.00089 5.06408 0 7.48044 0 10C0 12.5196 1.00089 14.9359 2.78249 16.7175C4.56408 18.4991 6.98044 19.5 9.5 19.5ZM13.6934 8.25586L8.94336 13.0059C8.59453 13.3547 8.03047 13.3547 7.68535 13.0059L5.31035 10.6309C4.96152 10.282 4.96152 9.71797 5.31035 9.37285C5.65918 9.02773 6.22324 9.02402 6.56836 9.37285L8.3125 11.117L12.4316 6.99414C12.7805 6.64531 13.3445 6.64531 13.6896 6.99414C14.0348 7.34297 14.0385 7.90703 13.6896 8.25215L13.6934 8.25586Z",
    fill: "#76D33E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4066_9754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoplightGreen);
export default __webpack_public_path__ + "static/media/stoplight_green.c1abc18eb351f1c1e2e04d5e081cfab7.svg";
export { ForwardRef as ReactComponent };